import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ palette, spacing, breakpoints }) => ({
  viewport: {
    alignItems: "flex-start",
    backgroundColor: palette.background.default,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    left: spacing(8),
    position: "absolute",
    right: 0,
    top: spacing(8),
    transition: "left 200ms",
    bottom: 0,

    [breakpoints.down("sm")]: {
      left: 0,
    },
  },

  "viewport--expanded": {
    [breakpoints.up("lg")]: {
      left: spacing(32),
    },
  },
}));
